
import React from "react";
import { Link } from "react-router-dom";
import "../styles/MotionHeading.css";
import PatternBG from "./PatternBG";

// 🎥 Vimeo video embeds
const videos = [
  {
    title: "Airpods",
    src: "https://player.vimeo.com/video/1134874161?loop=1&title=0&byline=0&portrait=0&dnt=1",
    ratio: "16 / 9",
  },
  {
    title: "Parallax Scrolling",
    src: "https://player.vimeo.com/video/1134874262?loop=1&title=0&byline=0&portrait=0&dnt=1",
    ratio: "16 / 9",
  },
  {
    title: "Logo",
    src: "https://player.vimeo.com/video/1134874240?loop=1&title=0&byline=0&portrait=0&dnt=1",
    ratio: "16 / 9",
  },
  {
    title: "Paper Tear",
    src: "https://player.vimeo.com/video/1134874139?loop=1&title=0&byline=0&portrait=0&dnt=1",
    ratio: "16 / 9",
  },
  {
    title: "Zoom Transition",
    src: "https://player.vimeo.com/video/1134874301?loop=1&title=0&byline=0&portrait=0&dnt=1",
    ratio: "16 / 9",
  },
  {
    title: "Ice Cream Carousel – Figma",
    src: "https://player.vimeo.com/video/1134874330?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "Chess Board",
    src: "https://player.vimeo.com/video/1134874374?loop=1&title=0&byline=0&portrait=0&dnt=1",
    ratio: "1 / 1",
  },
];


// 📐 collage layout variants
const variants = [
  { span: 7, ty: 34, rot: -1.2 },
  { span: 5, ty: -42, rot: 1.3 },
  { span: 6, ty: 65, rot: -0.8 },
  { span: 6, ty: -26, rot: 1.1 },
  { span: 5, ty: 36, rot: -0.6 },
  { span: 7, ty: -30, rot: 0.9 },
];

export default function MotionHeading() {
  return (
    <section
      id="motion-heading"
      className="motion-heading"
      aria-label="Motion Design and Motion Graphics"
    >
      {/* Background Pattern */}
      <PatternBG
        variant="wavy"
        speed={20}
        density={72}
        stroke="rgba(86, 156, 214, 0.45)"

        lineWidth={1.2}
      />

      <div className="motion-inner">
        <h2>Motion Design &amp; Motion Graphics</h2>

        {/* 🎞 Main video + button */}
        <div className="motion-top-row">
          <div
            className="video-wrapper main-video"
            style={{
              "--span": 7,
              "--ty": "0px",
              "--rot": "0deg",
              "--ratio": "16 / 9",
            }}
          >
            <iframe
              src={videos[5].src}
              title="3D Carousel"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div>

          <div className="side-button">
            <Link to="/motion-design" className="btn-ghost">
              View More Samples→
            </Link>
          </div>
        </div>

        {/* 🎬 Two smaller collage videos */}
        <div className="motion-grid">
          {videos.slice(1, 3).map((v, i) => {
            const c = variants[i];
            return (
              <div
                key={v.title}
                className="video-wrapper"
                style={{
                    "--span": c.span,
                    "--ty": `${c.ty}px`,
                    "--rot": `${c.rot}deg`,
                    "--ratio": v.ratio,
                }}

              >
                <iframe
                  src={v.src}
                  title={v.title}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}